(function ($) {

    $.ZagScrollAnimate = function (element, options) {

        var component = element;
        var options = $.extend({}, $.ZagScrollAnimate.defaultOptions, options);
        ZagScrollAnimateSetup(component, options);

    };

    ZagScrollAnimateSetup = function (component, options) {

        options.targets.forEach((target) => {
            count = 0;
            component.find(target.selector).each(function () {
                $(this).attr("data-scroll_animate_type", target.type);
                $(this).attr("data-scroll_animate_stagger", count * target.stagger);
                count++;
            });
        });

        var waypoint = new Waypoint({
            element: component,
            handler: function (direction) {
                ZagScrollAnimateExecute(this.element, direction);
            },
            triggerOnce: true,
            offset: options.offset + '%'
        })
    };

    ZagScrollAnimateExecute = function (waypoint, direction) {
        if (direction == "down") {
            waypoint.find("[data-scroll_animate_type]").each(function () {
                var element = $(this);
                var type = $(this).attr("data-scroll_animate_type");
                var stagger = $(this).attr("data-scroll_animate_stagger");

                setTimeout(
                    function (e) {
                        element.addClass("animate__animated");
                        element.addClass(type);
                    }, stagger);
            });
        }
    };

    $.fn.ZagScrollAnimate = (function (options) {
        return this.each(function () {
            (new $.ZagScrollAnimate($(this), options));
        });
    });

    $.ZagScrollAnimate.defaultOptions = { offset: 50, targets: [] };

})(jQuery);